export class ModuleSelectionFilter {
  CompanyId: number;
  UserId: string;

  constructor(companyId?: number, userId?: string) {
    this.CompanyId = null;
    this.UserId = null;

    if (companyId) {
      this.CompanyId = companyId;
    }

    if (userId) {
      this.UserId = userId;
    }
  }
}
